
export const useGetSignedInUserDetails = () => {
    const userName = JSON.parse(window.sessionStorage.getItem("UserAccount"))?.["name"];

    return {
        userName
    }
}